import { render, staticRenderFns } from "./EducationCardSkeleton.vue?vue&type=template&id=103da2b2&scoped=true"
import script from "./EducationCardSkeleton.vue?vue&type=script&lang=js"
export * from "./EducationCardSkeleton.vue?vue&type=script&lang=js"
import style0 from "./EducationCardSkeleton.vue?vue&type=style&index=0&id=103da2b2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "103da2b2",
  null
  
)

export default component.exports